import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { LoginGuardService } from '@services/auth/loginGuard.service';
import { Observable, of } from 'rxjs';
import { RedirectGuardService } from '@services/auth/redirectGuard.service';
import { isPlatformBrowser } from '@angular/common';

/**
 * Guard de redirección en el dashboard. Si el usuario está autenticado, redirige al panel
 * correspondiente a su rol; de lo contrario permite el acceso solo a la ruta de login.
 */
@Injectable({providedIn: 'root'})

export class RedirectService implements CanActivate {

    private readonly _platformId = inject(PLATFORM_ID);
    private readonly _router = inject(Router)
    private readonly _loginGuard = inject(LoginGuardService)
    private readonly _redirectService = inject(RedirectGuardService)


  /**
   * Evalúa si la ruta puede activarse y gestiona la redirección según el estado de sesión.
   * @param route - Snapshot de la ruta a activar
   * @param state - Estado actual del router
   * @returns `Observable<true>` si el acceso es permitido, `Observable<false>` si se redirige al login
   */
      canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (isPlatformBrowser(this._platformId)) {

      if (this._loginGuard.accessLogin()) {
        this._redirectService.redirectService();
        return of(true);
      } else {
        if (route.routeConfig?.path === 'login') {
          return of(true);
        }
        void this._router.navigate(['auth/login']);
        return of(false);
      }
    } else {
      return of(false);
    }
  }
    
}